// @flow
// $FlowFixMe
import { EventTypes } from 'redux-segment'
export const customMapper = {
  mapper: {
    '@@redux-form/INITIALIZE': (getState: Function, action: Object) => {
      return {
        eventType: EventTypes.track,
        eventPayload: {
          event: `${action.meta.form}Start`
        }
      }
    },
    '@@redux-form/CHANGE': (getState: Function, action: Object) => {
      return {
        eventType: EventTypes.track,
        eventPayload: {
          event: `${action.meta.form}FieldUpdated`,
          properties: {
            field: action.meta.field,
            value: action.payload
          }
        }
      }
    },
    '@@redux-form/SET_SUBMIT_SUCCEEDED': (getState: Function, action: Object) => {
      return {
        eventType: EventTypes.track,
        eventPayload: {
          event: `${action.meta.form}SubmitSucceeded`
        }
      }
    },
    'stripe/PROCESS_PAYMENT': (getState: Function, action: Object) => {
      return {
        eventType: EventTypes.identify,
        eventPayload: {
          userId: action.payload.booking.member.email,
          traits: {
            firstName: action.payload.booking.member.firstName,
            lastName: action.payload.booking.member.lastName,
            email: action.payload.booking.member.email
          }
        }
      }
    },
    'stripe/PROCESS_PAYMENT_SUCCESS': (getState: Function, action: Object) => {
      return {
        eventType: EventTypes.track,
        eventPayload: {
          event: `StripePaymentSuccess`
        }
      }
    },
    'stripe/PROCESS_PAYMENT_FAILED': (getState: Function, action: Object) => {
      return {
        eventType: EventTypes.track,
        eventPayload: {
          event: `StripePaymentFailed`
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/config/customMapper.js